import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CustomButtonProps } from '../../utils/interfaces';

// Custom styled components using props
export const AppButton = styled(Button)<CustomButtonProps>(({ theme, others, background, border }) => {
  return {
    textTransform: 'capitalize',
    boxShadow: 'none !important',
    background: background,
    color: others?.color || theme.palette.KenColors.kenWhite,
    '&:hover': {
      background: background,
      color: others?.color || theme.palette.KenColors.kenWhite,
      border: border,
    },
    '&:active': {
      background: background,
      color: others?.color || theme.palette.KenColors.kenWhite,
      border: border,
    },
    '&:focus': {
      background: background,
      color: others?.color || theme.palette.KenColors.kenWhite,
      border: border,
    },
    ...others,
  };
});
